<script>
import ProjectSingle from './ProjectSingle.vue';
import projects from '../../data/projects';

export default {
	components: { ProjectSingle },
	emits: ['select'],
	data: () => ({ projects }),
};
</script>

<template>
	<div class="projects-list">
		<ProjectSingle
			v-for="(project, i) in projects"
			:key="project.id"
			:project="project"
			:index="i"
			@select="$emit('select', $event)"
		/>
	</div>
</template>

<style scoped>
.projects-list {
	width: 100%;
}
</style>
